import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const ColorBlockSelect = ({ data, handleButtonColorChange, buttonColorID, buttonColorHex }) => {
  const colorData = data;
  const colorRowArray = [];
  let tempArray = [];
  colorData.forEach((color, index) => {
    tempArray.push(color);
    if ((index + 1) % 4 === 0) {
      colorRowArray.push(tempArray);
      tempArray = [];
    }
  });

  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 180 }}>
        <Select
          id="buttonColorSelect"
          value={buttonColorID}
          size="small"
          displayEmpty
          renderValue={() => (
            <div style={{ height: '25px', width: '40px', backgroundColor: buttonColorHex, float: 'left' }} />
          )}
        >
          {colorRowArray && colorRowArray.map((colorRow, index) => (
            <MenuItem key={`outer_${index + 1}`}>
              <div className="cursor-default">
                {colorRow && colorRow.map((color) => (
                  // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/no-static-element-interactions
                  <div
                    className="color-block-multi cursor-pointer"
                    style={{ backgroundColor: color.hex }}
                    id={color.id}
                    key={`block_${color.id}`}
                    onClick={() => handleButtonColorChange(color.id, color.hex, color.name)}
                    onKeyUp={() => handleButtonColorChange(color.id, color.hex, color.name)}
                  />
                ))}
              </div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ColorBlockSelect;
